module.exports = __webpack_public_path__ + "static/media/friggenheavymate.7655577d.wav";